import React from 'react';
import RibbonItem from '../../components/ImpactRibbonItem/RibbonItem';
import { RibbonItemConfig } from './config';
import './ImpactNumbers.css';

const ImpactNumbers = () => {
  return (
    <div className='impact-ribbon'>
      <div className="ribbon-inner-container">
        {RibbonItemConfig.map((item, index) => (
          <RibbonItem 
            key={index}
            icon={item.icon}
            number={item.number}
            description={item.description}
          />
        ))}
      </div>  
    </div>
  );
};

export default ImpactNumbers;